import { render, staticRenderFns } from "./CoreItemThree.vue?vue&type=template&id=e0dda156&scoped=true"
import script from "./CoreItemThree.vue?vue&type=script&lang=js"
export * from "./CoreItemThree.vue?vue&type=script&lang=js"
import style0 from "./CoreItemThree.vue?vue&type=style&index=0&id=e0dda156&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_85618a750ecf9a6cb90ae78d3f60d7c3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0dda156",
  null
  
)

export default component.exports